import { render, staticRenderFns } from "./RadioButtonComponent.vue?vue&type=template&id=e13b3498&"
import script from "./RadioButtonComponent.vue?vue&type=script&lang=js&"
export * from "./RadioButtonComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports